module.exports = __webpack_public_path__ + "img/4b49198.png";